import { render, staticRenderFns } from "./Purchase.vue?vue&type=template&id=e5c1b384&scoped=true"
import script from "./Purchase.vue?vue&type=script&lang=js"
export * from "./Purchase.vue?vue&type=script&lang=js"
import style0 from "./Purchase.vue?vue&type=style&index=0&id=e5c1b384&prod&lang=css"
import style1 from "./Purchase.vue?vue&type=style&index=1&id=e5c1b384&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e5c1b384",
  null
  
)

export default component.exports